import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import { Box, Button, Grid, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { DatePicker as KendoDatePicker } from "@progress/kendo-react-dateinputs";
import _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import i18_en from '../../../../jsonStore/i18_en.json';
import { areaSelectionRefreshReducer } from "../../../../shared/ReduxStore/Reducers/areaSelectionReducer";
import { drageItemsReducer } from "../../../../shared/ReduxStore/Reducers/dragReducer";
import AlertComponent from '../../../../shared/common-utilities/common/AlertComponent';
import { CommonConst as Consts } from "../../../../shared/common-utilities/enums/CommonConst.jsx";
import { PlanFunctionsForFlag } from '../../../../shared/common-utilities/enums/PlanFunctionsEnum';
import dataStorageService from '../../../../shared/common-utilities/services/DataStorageService.jsx';
import commonApiService from '../../../../shared/common-utilities/services/commonApiService';
import { ApiConst, baseUrl, batchUrl, company, getPartialTrip, planMovementsNew, postSetFreeRoutes } from '../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts';
import getSetDataService from "../../../../shared/common-utilities/services/getSetDataService";
import LeafletMap from '../../common/LeafletMap/LeafletMap';
import ModalComponent from '../../common/Modal/ModalComponent';
import Spinner from "../../common/Spinner/Spinner";
import WindowComponent from '../../common/Window/WindowComponent';
import MovementDetails from './MovementDetails';
import { listSelectionReducer } from "../../../../shared/ReduxStore/Reducers/listSelectionReducer";

let service = getSetDataService();
let apiService = commonApiService();
let storageService = dataStorageService();

let selectedData = [];
const center = [51.643838, 5.231913];
const toDayDate = new Date();
const minDate = new Date(toDayDate.getFullYear() - 50, toDayDate.getMonth(), toDayDate.getDate());
const maxDate = new Date(toDayDate.getFullYear() + 50, toDayDate.getMonth(), toDayDate.getDate());

const MapView = () => {
  const childRef = useRef();
  //#region Hook states
  const [mapKey, setMapKey] = React.useState(1);
  const [isShow, setFlagShow] = React.useState(false);
  const [mapDetails, setMapDetails] = React.useState([]);
  const [tileItems, setTileItems] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isMap, setIsMap] = useState(true)
  const [isPin, setIsPin] = useState(true)
  const [isActive, setActive] = useState(false);
  // const [drageItemsData, setDrageItemsData] = useState(JSON.parse(storageService.getLocalStorageData('mapItem')))
  const [drageItemsData, setDrageItemsData] = useState([])
  const [isEnableCluster, setIsEnableCluster] = useState(false);
  const [isEnableRectSelection, setIsEnableRectSelection] = useState(true);
  const [isEnableLassoSelection, setIsEnableLassoSelection] = useState(false);
  const [isEnableMarkerSelection, setIsEnableMarkerSelection] = useState(false);
  const [isEnableRouteSelection, setIsEnableRouteSelection] = useState(false);
  const [isEnableOptimizeRoute, setIsEnableOptimizeRoute] = useState(false);
  const [isEnableCalculateIcon, setIsEnableCalculateIcon] = useState(false);
  const [isEnableSetFreeIcon, setIsEnableSetFreeIcon] = useState(false);
  const [isEnablePlanOnNewTrip, setIsEnablePlanOnNewTrip] = useState(false);
  const [isEnableRemoveTrip, setIsEnableRemoveTrip] = useState(false);
  const [disableReportIcon, setDisableReportIcon] = useState(true);
  const [coordinatesData, setCoordinatesData] = useState([]);
  const [totalItemsSelected, setTotalItemsSelected] = useState([]);

  const [commonPopupParameters, setCommonPopupParameters] = useState({});
  const [errorMessage, setErrorMessage] = useState(null);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [isSuccessSnackbarOpen, setSuccessSnackbarOpen] = useState(false);
  const [successSnackbarMessage, setSuccessSnackbarMessage] = useState('');
  const [isErrorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [errorSnackbarMessage, setErrorSnackbarMessage] = useState('');
  const [isDisplayDrillDownButton, setIsDisplayDrillDownButton] = useState(false);
  const [openPlanNewTripPopup, setOpenPlanNewTripPopup] = useState(false);
  const [currentDate, setCurrentDate] = useState("");
  const [drillDownButtonURL, setDrillDownButtonURL] = useState();
  const [droppedEventId, setDroppedEventId] = useState();
  const [initialTrigger, setInitialTrigger] = useState(true);

  const mapPlanActions = ['RectangularSelection', 'LassoSelection', 'OptimizeRoute', 'CalculatePartialTrip', 'SetFree', 'PlanonNewTrip', 'Delete Partial Trip', 'RemoveFromMap', 'RefreshMap'];

  //#endregion Hook states

  //#region Hook Selctor
  const mapRefreshReducerData = useSelector(state => state.mapRefresh.isRefreshMapData);
  const mapDataReducerData = useSelector(state => state.mapData.values);
  const listSelectionReducerData = useSelector(state => state.listSelection);
  const drageItems = useSelector(state => state.drag);

  const dispatch = useDispatch()
  const navigate = useNavigate();
  //#endregion Hook Selctor

  const onShortcutKeyPress = (event) => {
    if (event.key === 'F3') {
      setIsEnableRectSelection(true);
    }
    // else if (event.ctrl && event.shiftKey && event.key.toLowerCase() === 'c') {
    //   setIsEnableCluster(true);
    // }
  };

  //#region Hooks  

  useEffect(() => {
    setIsEnableRectSelection(false)
    setIsEnableLassoSelection(false)
    setTimeout(() => {
      setDrageItemsData(JSON.parse(storageService.getLocalStorageData('mapItem')))
    }, 100);
  }, [])

  // useEffect(() => {
  //   setDrageItemsData(mapDataReducerData)
  // }, [mapDataReducerData])

  useEffect(() => {
    if (window.location.hash.includes("map")) {
      setIsMap(false);
      setIsPin(false)
    }
    if (drageItemsData?.length > 0) {
      RefreshData();
    }
  }, [drageItemsData]);

  useEffect(() => {
    if (mapDataReducerData) {
      if (drageItemsData?.length > 0) {
        let clone = _.cloneDeep(drageItemsData);
        mapDataReducerData.forEach(element => {
          // const _newIds = _.concat(element.items.actualSelectedIds, element.items.partialSelectedIds);          
          let oldItem = clone.find(e => e.source == element.source);
          if (oldItem) {
            const _oldIds = _.concat(oldItem.items.actualSelectedIds, oldItem.items.partialSelectedIds);

            const _updActuals = element.items.actualSelectedIds.filter(key => !_.includes(_oldIds, key));
            const _updPartials = element.items.partialSelectedIds.filter(key => !_.includes(_oldIds, key));

            oldItem.items.actualSelectedIds = _.concat(oldItem.items.actualSelectedIds, _updActuals)
            oldItem.items.partialSelectedIds = _.concat(oldItem.items.partialSelectedIds, _updPartials)
          } else {
            const _newIds = _.concat(element.items.actualSelectedIds, element.items.partialSelectedIds);
            clone.push({
              source: element?.source,
              items: {
                actualSelectedIds: element?.source == Consts.PartialTrips ? [] : element?.items?.actualSelectedIds,
                partialSelectedIds: element?.source == Consts.PartialTrips ? _newIds : element?.items?.partialSelectedIds,
              }
            })
          }
          // var result = _newIds.filter(ele => _oldIds.some(o => o != ele));

          // const updatedSelectedState = clone.filter(e=> e.source == element.source).filter(([key]) => !ids.has(key))
          // );
          // const updatedPartialSelectedState = Object.fromEntries(
          //   Object.entries(myPartialSelectedState).filter(([key]) => !ids.has(key))
          // );
        });
        setDrageItemsData(clone)
      } else {
        setDrageItemsData(mapDataReducerData)
      }
    }
  }, [mapDataReducerData])

  useEffect(() => {
    if (mapRefreshReducerData) {
      RefreshData()
      setIsEnableRectSelection(false)
      setIsEnableLassoSelection(false)
    }
  }, [mapRefreshReducerData])


  useEffect(() => {
    if (listSelectionReducerData) {
      setIsEnableRectSelection(false)
      setIsEnableLassoSelection(false)
      setIsEnableRemoveTrip(false);
      setIsEnablePlanOnNewTrip(false);
      setIsEnableOptimizeRoute(false);
      setIsEnableCalculateIcon(false);
      setIsEnableSetFreeIcon(false);
      setDisableReportIcon(true)

      if (listSelectionReducerData.movementIds.length > 0) {
        setIsEnableRemoveTrip(true);
        setIsEnablePlanOnNewTrip(true);
      }
      // if (listSelectionReducerData.partialTripIds.length > 0) {
      //   setDisableReportIcon(false);
      // }
      if (listSelectionReducerData.partialTripIds.length == 1) {
        setIsEnableRemoveTrip(true);
        setIsEnableOptimizeRoute(true);
        setIsEnableCalculateIcon(true);
        setDisableReportIcon(false)
      }
      if (listSelectionReducerData.routeIds.length == 1) {
        setIsEnableSetFreeIcon(true);
      }
      selectedData = listSelectionReducerData;
    }
  }, [listSelectionReducerData])

  useEffect(() => {
    document.addEventListener('keydown', onShortcutKeyPress);

    // Remove event listener when the component unmounts
    return () => {
      document.removeEventListener('keydown', onShortcutKeyPress);
    };
  }, [onShortcutKeyPress])
  //#endregion Hooks

  //#region Common methods

  const RefreshData = async (data) => {
    let _tempdata = []
    await Promise.allSettled(drageItemsData?.filter(e => e.source != 'dottedLineIds').map(async (e, index) => {
      await getActualData(e).then((tData) => {
        tData?.forEach(element => {
          _tempdata.push(element)
        });
      });
    }));

    setTileItems(_tempdata);
    setDataInMap(_tempdata)
  }

  // const disptachEvent = () => {
  //   const obj = {
  //     source: drageItemsData.source,
  //     destination: 'Map',
  //     eventType: drageItemsData.eventType,
  //     items: drageItemsData.items
  //   }
  //   dispatch(drageItemsReducer(obj))
  // };

  const getActualData = async (lstItems) => {
    const totalIds = lstItems?.items?.actualSelectedIds.concat(lstItems?.items?.partialSelectedIds);
    let ids = totalIds && totalIds.map(item => 'id eq ' + item).join(' or ');
    let header =  {
      // "Company": "CRONUS International Ltd.",
      "Content-Type": "application/json",
      "If-Match": "*",
      "prefer": 'odata.maxpagesize=750'
    }
    if (lstItems.source == 'movements') {
      const url = `${company}/${lstItems.source}?&$expand=movementActions&$filter=(${ids})`;
      const rBody = {
        requests : [
          {
            method: "GET",
            url : url,
            headers :header
          }
        ]
      }
      // let ids = totalIds && totalIds.map(item => "'" +item +"'").join(', ');
      // if (lstItems.source == 'movements') {
      //   const url = `${baseUrl}/${lstItems.source}?&$expand=movementActions&$filter=id in (${ids})`;
      return await apiService.post(batchUrl, rBody).then(response => {
        let res = response.responses[0].body.value
        res.map(function (e) {
          e.selected = (lstItems.items.actualSelectedIds.indexOf(e.id) != -1);
        });
        return res
      });
    } else if (lstItems.source == 'partialTrips') {
      const url = `${company}/${lstItems.source}?&$expand=routes&$filter=(${ids})`;
      const rBody = {
        requests : [
          {
            method: "GET",
            url : url,
            headers : header
          }
        ]
      }
      return await apiService.post(batchUrl, rBody).then(response => {
        return response.responses[0].body.value;
      });
    } else {
      return null;
    }
  }

  const setDataInMap = (lstItems) => {
    let _mapData = [];
    const movements = lstItems.filter(x => !x.tripNo);
    const trips = lstItems.filter(x => x.tripNo);
    // if (source == 'movements') {
    const _grpData1 = _.groupBy(movements, 'kindofMovement');
    const _keys1 = Object.keys(_grpData1);

    _keys1?.forEach(_key => {
      _mapData.push(generateMapData('movements', _key, _grpData1));
    });

    const _grpData2 = _.groupBy(trips, 'id');
    const _keys2 = Object.keys(_grpData2);

    _keys2?.forEach(_key => {
      _mapData.push(generateMapData('partialTrips', _key, _grpData2));
    });
    //setMapDetails(_.groupBy(mapDetails.flat(), 'id'));
    setMapDetails(_mapData.flat());
    
    setTotalItemsSelected(_mapData.flat())
    setInitialTrigger(false)
    // } else if (source == 'partialTrips') {
    //   const _grpData = _.groupBy(lstItems, 'id');
    //   const _keys = Object.keys(_grpData);

    //   _keys?.forEach(_key => {
    //     mapDetails.push(generateMapData(source, _key, _grpData));
    //   });
    //   setMapDetails(mapDetails.flat());
    // }
  }

  const generateMapData = (source, key, grpData) => {
    const tValues = [];
    let type = 'polyline';

    grpData[key].forEach(element => {
      if (source === 'movements') {
        type = (["Shuttle", "Direct"].includes(key) ? "polyline" : "marker");
        element.movementActions.forEach(mAction => {
          const _selected = listSelectionReducerData?.movementIds?.length == 0 ? element?.selected : listSelectionReducerData?.movementIds?.some(e => element.id == e);
          const _ids = drageItemsData?.find(e => e.source == 'dottedLineIds')?.ids;
          const _dottedLine = _.includes(_ids ? _ids : [], element.id)
          tValues.push(service.extractCommonData(element, mAction, source, drageItemsData, type, null, _selected, _dottedLine));
        });
      } else {
        element.routes?.forEach(mAction => {
          const _selected = listSelectionReducerData?.partialTripIds?.length == 0 ? element?.selected : listSelectionReducerData?.partialTripIds?.some(e => element.id == e);
          const _ids = drageItemsData?.find(e => e.source == 'dottedLineIds')?.ids;
          const _dottedLine = _.includes(_ids ? _ids : [], element.id)
          tValues.push(service.extractCommonData(element, mAction, source, drageItemsData, type, true, _selected, _dottedLine));
        });
      }
    });
    return tValues;
  }

  const setErrorParameterAndMessage = (errMsg) => {
    setCommonPopupParameters({
      title: 'Error'
    });
    setErrorMessage(errMsg);
    setOpenConfirmationModal(true);
  };

  const setSuccessSnackbarAndMessage = (message, noDrillDown = true) => {
    setSuccessSnackbarMessage(message);
    setSuccessSnackbarOpen(true);
    if (noDrillDown) {
      setDrillDownFlagAndURL(false, '');
    }
  };

  const handleSuccessSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSuccessSnackbarOpen(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setErrorSnackbarOpen(false);
  };

  const setDrillDownFlagAndURL = (flag = false, drillDownULR = '') => {
    setIsDisplayDrillDownButton(flag);
    setDrillDownButtonURL(drillDownULR);
  }

  const closeConfirmationModal = (e, flag, id = null) => {
    setOpenConfirmationModal(false);
    setCommonPopupParameters({});
    if (e && flag && (flag === PlanFunctionsForFlag.SetFreeRoutes)) {
      let apiEndPointName = '';
      if (flag === PlanFunctionsForFlag.SetFreeRoutes) {
        apiEndPointName = postSetFreeRoutes;
      }
      onPlanButtonsSetFree(null, e, apiEndPointName, flag, i18_en.operationSuccessful);
    } else if (e && flag && flag === PlanFunctionsForFlag.CalculateConfirmation) {
      callPlanFunctionPostWithIdAPI(getPartialTrip, null, listSelectionReducerData.routeIds[0], 'Microsoft.NAV.calculateIncludingActionTimes', e, flag, false, i18_en.operationSuccessful);
    } else if (e && flag && flag === PlanFunctionsForFlag.PlanMovementsNewConfirmation) {
      postPlanMovementsAPI(e, e.movementlines);
    } else if (e && flag && flag === PlanFunctionsForFlag.ChangePTResourceConfirmation) {
      callAPIChangePtResource(id, e);
    } else if (e && flag && flag === PlanFunctionsForFlag.DeletePartialTrip) {
      e.confirmation = true
      const param = { input: JSON.stringify(e) }
      callPlanFunctionPostWithIdAPI(getPartialTrip, null, id, `Microsoft.NAV.deletePartialTrip`, param, flag, true, i18_en.operationSuccessful);
    }

    if (e === null && flag === undefined) {
      // clearMap(); //NEED to Implement
      // dispatch(areaSelectionRefreshReducer({ isRefresh: true }));
    }
    setErrorMessage(null);
  }


  const handleDateChange = event => {
    setCurrentDate(event.target.value);
  }

  //#region Common methods


  //#region Plan actions

  const onPlanButtons = (e, url) => {
    if (e?.event == 'postPlanMovementsAPI') {
      const movementObjects = service.movementObject(e?.movIds, Consts.Movements);
      const inputTripDateObject = { planOnPartialTrip: e?.tripId, fromMap: true };
      const params = service.movementLinesAndOperationDeatilObject(movementObjects, JSON.stringify(inputTripDateObject), Consts.Movements);
      postPlanMovementsAPI(params, movementObjects, true);
    } else if (e === 'rectangular-selection') {
      setIsEnableLassoSelection(false)
      setTimeout(() => { setIsEnableRectSelection(prev => { return !isEnableRectSelection }) }, 200);
    } else if (e === 'lasso-selection') {
      setTimeout(() => {
        setIsEnableLassoSelection(prev => { return !isEnableLassoSelection })
        setIsEnableRectSelection(false)
      }, 200);
    } else if (e === 'optimize-route') {
      // childRef.current.onPlanButtonsOptimizeRoute(selectedData?.partialTripIds[0]);
      onPlanButtonsOptimizeRoute(baseUrl, 'partialTrips', listSelectionReducerData.partialTripIds[0]);
    } else if (e === 'calculate-partial-trip') {
      onCalculateIconClick(selectedData?.partialTripIds[0]);
    } else if (e === 'set-free') {
      onPlanButtonsSetFree(selectedData?.routeIds, null, postSetFreeRoutes, PlanFunctionsForFlag.SetFreeRoutes, i18_en.operationSuccessful);
    } else if (e === 'planon-new-trip') {
      onPlanTripButtons(selectedData);
    } else if (e === 'remove-from-map') {
      RemoveSelected(selectedData);
    } else if (e === 'delete-partial trip') {
      // listSelectionReducerData.partialTripIds.forEach(async element => {
      //   await callPlanFunctionPostWithIdAPI(getPartialTrip, null, element, 'Microsoft.NAV.deletePartialTrip', { "input": "{}" }, PlanFunctionsForFlag.DeletePartialTrip, true, i18_en.operationSuccessful);  
      // });
      callPlanFunctionPostWithIdAPI(getPartialTrip, null, selectedData?.partialTripIds[0], 'Microsoft.NAV.deletePartialTrip', { "input": "{}" }, PlanFunctionsForFlag.DeletePartialTrip, true, i18_en.operationSuccessful);
    } else if (e === 'refresh-map') {
      RefreshData();
    }
  };

  const onPlanButtonsOptimizeRoute = (url, flag, selectedId) => {
    const param = { input: "{}" };
    apiService.postWithId(url, flag, selectedId, 'Microsoft.NAV.optimizeRouteAndGetRouteDetails', param).then(response => {
      if (response !== null && response !== undefined && response.error !== null && response.error !== undefined && response.error) {
        setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
      } else {
        RefreshData();
        // in progress
      }
    }).catch(error => {
      console.error('API error:', error);
    })
  }

  // Common api call
  const callPlanFunctionPostWithIdAPI = (url, flag, id, routeExpand, obj, forFlag, isRefresh, snackbarMessage = i18_en.operationSuccessful) => {
    apiService.postWithId(url, flag, id, routeExpand, obj).then(response => {
      if (response) {
        if (response.error) {
          setErrorParameterAndMessage(response?.error?.message.split('CorrelationId')[0]);
        } else {
          const result = JSON.parse(response?.value);
          if (result) {
            if (service.apiOKResultChecker(result)) {
              setSuccessSnackbarAndMessage(snackbarMessage);
              if (isRefresh) {
                const ids = JSON.parse(response.value)?.movementIds?.toString()?.replaceAll('{', '')?.replaceAll('}', '')?.split(',');
                RemoveSelected(listSelectionReducerData, ids, Consts.PartialTrips)
                // debugger
                // setTimeout(() => {
                //   dispatch(areaSelectionRefreshReducer({ isRefresh: true }));
                // }, 100);
                // dispatch(areaSelectionRefreshReducer({ isRefresh: true }));
                // RefreshData();
              }
              setOpenConfirmationModal(false);
            } else if (result.parameters[0] !== null && result.parameters[0] !== undefined && (result.parameters[0].name === 'confirmation' || result.parameters[0].name === 'warnings')) {
              const params = {
                title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
                id: id,
                for: forFlag,
                parameters: result.parameters,
                result: result,
                obj: obj
              }
              setOpenConfirmationModal(true);
              setCommonPopupParameters(params);
            } else {
              setOpenConfirmationModal(false);
            }
          } else {
            setOpenConfirmationModal(false);
          }
        }
      }
    })
  }

  // Calculate Route
  const onCalculateIconClick = (selectedId) => {
    const param = { input: "{}" };
    apiService.postWithId(getPartialTrip, null, selectedId, 'Microsoft.NAV.calculateIncludingActionTimes', param).then((response) => {
      if (response !== null && response !== undefined) {
        if (response.error !== null && response.error !== undefined && response.error) {
          setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
        } else {
          const result = JSON.parse(response?.value);
          if (service.apiResultChecker(result)) {
            const param = {
              title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
              parameters: result.parameters,
              for: PlanFunctionsForFlag.CalculateNotification
            };
            setOpenConfirmationModal(true);
            setCommonPopupParameters(param);
            if (service.apiOKResultChecker(result)) {
              setSuccessSnackbarAndMessage(i18_en.operationSuccessful);
            }
          } else if (result?.parameters && result.parameters[0]?.type === 'Dialog.ConfirmSingleLine') {
            const param = {
              title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
              parameters: result.parameters,
              for: PlanFunctionsForFlag.CalculateConfirmation,
            };
            setOpenConfirmationModal(true);
            setCommonPopupParameters(param);
          } else {
            if (service.apiOKResultChecker(result)) {
              setSuccessSnackbarAndMessage(i18_en.operationSuccessful);
            }
          }
        }
      }
    })
  }

  // Set Free
  const onPlanButtonsSetFree = (selectedIds, requestParam, apiEndPointName, forFlag, successMessage = i18_en.operationSuccessful) => {
    const movementObjects = service.movementObject(selectedIds, 'routes', requestParam);
    const obj = requestParam ? requestParam : service.movementLinesAndOperationDeatilObject(movementObjects, "{}", 'routes');
    apiService.post(apiEndPointName, obj).then(response => {
      if (response) {
        if (response.error) {
          setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
        } else {
          const result = JSON.parse(response?.operationDetail[0]?.result);
          const input = response.operationDetail[0]?.input ? JSON.parse(response.operationDetail[0]?.input) : null;
          if (result) {
            if (service.apiOKResultChecker(result)) {
              setSuccessSnackbarAndMessage(successMessage);
              if (forFlag === PlanFunctionsForFlag.SetFreeRoutes) {
                // clearMap();
                const ids = JSON.parse(response?.operationDetail?.[0]?.result)?.movementIds?.toString()?.replaceAll('{', '')?.replaceAll('}', '')?.split(',');
                RemoveSelected(listSelectionReducerData, ids, Consts.PartialTrips)
              }
            } else if (result.parameters && (result.parameters[0]?.type === 'Dialog.SelectMenuSingle' || result.parameters[0]?.name === 'tripDate' || result.parameters[0]?.name === 'postponeDate'
              || (result.parameters[0]?.name === 'hookOffActionCode' && result.parameters[1]?.name === 'hookOnActionCode') || result.parameters[0].name === 'deleteTripQuestion'
              || result.parameters[0].name === 'alreadyPlannedWarning' || result.parameters[0].name === 'planOtherMovements' || result.parameters[0].name === 'planLimitExceeded')) {
              const param = {
                movementlines: movementObjects,
                title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
                parameters: result.parameters,
                for: forFlag,
                input: input,
                data: result.data
              };
              setOpenConfirmationModal(true);
              setCommonPopupParameters(param);
            } else if (forFlag === PlanFunctionsForFlag.SetFreeRoutes && result.parameters && result.parameters[0]?.type.toLowerCase() === 'apigrid') {
              //   setPopupParameters({
              //     movementlines: movementObjects,
              //     title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
              //     result: response?.operationDetail[0]?.result,
              //     for: forFlag,
              //     input: response?.operationDetail[0]?.input,
              //     data: result.data
              //   });
              //   setdepotModalTital(i18_en.selectMovement);
              //   setOpenModalDepot(true);
              //   sendDataToParent(true, "openResModal");
            }
          }
        }
      }
    })
  }

  // Plan on Map
  const planNewTrip = () => {
    let actualSelectedIds = listSelectionReducerData.movementIds;
    let tempGridFlagVal = 'movements';
    // if (drageItems.source == "movements") {
    //   actualSelectedIds = drageItems?.items?.map(e => e.id);
    //   tempGridFlagVal = drageItems.source;
    // }
    let date = currentDate.getDate();
    let month = currentDate.getMonth() + 1;
    let year = currentDate.getFullYear();
    let tripDate = year + "-" + month + "-" + date;
    const movementObjects = service.movementObject(actualSelectedIds, tempGridFlagVal);
    const inputTripDateObject = {
      tripDate: moment(tripDate).format('yyyy-MM-DD'),
      fromMap: true
    };
    const obj = service.movementLinesAndOperationDeatilObject(movementObjects, JSON.stringify(inputTripDateObject), tempGridFlagVal);
    postPlanMovementsAPI(obj, movementObjects);
    setOpenPlanNewTripPopup(false);
  }

  const PlanNewTripData = (prop) => {
    if (prop?.sendDataToParent) {
      setTimeout(() => {
        prop.sendDataToParent("planNewPopup");
      }, 100);
    }

    return (
      <Box
        sx={{
          bgcolor: "background.paper",
          p: 2
        }}
        id="planNewPopup"
      >
        <Typography variant="body2" sx={{ pr: .5 }}>Trip Date:</Typography>

        <KendoDatePicker defaultValue={currentDate || null} min={minDate} max={maxDate} onChange={handleDateChange} required={true} format={"dd-MM-yyyy"} />
      </Box>
    )
  }

  const PlanNewTripActionButtons = () => {
    return (
      <>
        <Button variant="contained" style={{}} onClick={planNewTrip}>
          OK
        </Button>
        <Button variant="outlined" onClick={() => setOpenPlanNewTripPopup(false)}>
          Cancel
        </Button>
      </>
    )
  }

  const onPlanTripButtons = () => {
    let actualSelectedIds = selectedData?.movementIds
    let tempGridFlagVal = 'movements';
    // if (drageItems.source === "movements") {
    //   actualSelectedIds = drageItems?.items?.map(e => e.id);
    //   tempGridFlagVal = drageItems.source;
    // }
    if (actualSelectedIds === null || actualSelectedIds === undefined || actualSelectedIds.length <= 0) {
      setErrorSnackbarOpen(true);
      setErrorSnackbarMessage(i18_en.selectAnyRow);
      return;
    }
    const movmentLines = service.movementObject(actualSelectedIds, tempGridFlagVal);
    const obj = service.movementLinesAndOperationDeatilObject(movmentLines, "{}", tempGridFlagVal);
    apiService.post(planMovementsNew, obj).then(response => {
      if (response !== null && response !== undefined && response.error !== null && response.error !== undefined && response.error) {
        setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
      } else {
        const result = JSON.parse(response?.operationDetail[0]?.result);
        if (result !== null && result !== undefined && result.parameters !== null && result.parameters !== undefined && result.parameters[0].name === 'tripDate') {
          let newDate = new Date(result.parameters[0].defaultValue);
          setCurrentDate(newDate);
          setOpenPlanNewTripPopup(true);
        }
      }
    })
    // setSelectedIds(actualSelectedIds);
  }

  const postPlanMovementsAPI = (obj, movementObjects) => {
    apiService.post(planMovementsNew, obj).then(response => {
      if (response !== null && response !== undefined) {
        if (response.error !== null && response.error !== undefined && response.error) {
          setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
        } else {
          const result = JSON.parse(response?.operationDetail[0]?.result);
          const successMessage = result?.drillDownMessage ? result?.drillDownMessage : i18_en.tripCreatedSuccessfully;
          const drillDownURL = result?.drillDownUrl ? result?.drillDownUrl : '';
          if (service.apiResultChecker(result)) {
            const param = {
              title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
              for: PlanFunctionsForFlag.PlanMovementsNewNotification,
              parameters: result.parameters
            };
            setOpenConfirmationModal(true);
            setCommonPopupParameters(param);
            if (service.apiOKResultChecker(result)) {
              setSuccessSnackbarAndMessage(successMessage);
              setDrillDownFlagAndURL(false, drillDownURL);
              // clearMap();
              RemoveSelected(listSelectionReducerData, response, Consts.Movements) //HERE
              RefreshData();
              dispatch(areaSelectionRefreshReducer({ isRefresh: true }));
            }
          } else if (result?.parameters && (result.parameters[0]?.type === 'Dialog.ConfirmSingleLine' || result.parameters[0]?.type === 'Dialog.SelectRadioButton')) {
            const input = response?.operationDetail[0]?.input ? JSON.parse(response?.operationDetail[0]?.input) : null;
            const param = {
              movementlines: movementObjects,
              title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
              for: PlanFunctionsForFlag.PlanMovementsNewConfirmation,
              parameters: result.parameters,
              input: input,
              obj: obj?.operationDetail[0]?.input
            };
            if (result.parameters[0].type === 'Dialog.ConfirmSingleLine') {
              param.data = result.data;
            } else if (result.parameters[0].type === 'Dialog.SelectRadioButton') {
              param.planOnPartialTrip = input?.planOnPartialTrip;
            }
            setOpenConfirmationModal(true);
            setCommonPopupParameters(param);
          } else {
            if (service.apiOKResultChecker(result)) {
              setSuccessSnackbarAndMessage(successMessage);
              setDrillDownFlagAndURL(false, drillDownURL);
              setOpenConfirmationModal(false);
              // clearMap();
              RemoveSelected(listSelectionReducerData, response, Consts.Movements) //HERE
              dispatch(areaSelectionRefreshReducer({ isRefresh: true }));   
            }
          }
        }
      }
    })
  }

  const callAPIChangePtResource = (ptrId, obj) => {
    const url = `${baseUrl}/partialTrips(${ptrId})/${ApiConst.changePtResource}`;
    const param = {
      input: JSON.stringify(obj)
    }
    // setIsLoading(true);
    apiService.post(url, param).then(response => {
      if (response !== null && response !== undefined) {
        if (response.error) {
          setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
        } else {
          const result = JSON.parse(response?.value);
          if (result.parameters !== null && result.parameters !== undefined && (result.parameters[0].type === 'Dialog.ConfirmSingleLine' || result.parameters[0].type === 'Dialog.SelectRadioButton')) {
            const param = {
              title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
              description: result.parameters[0].content,
              for: PlanFunctionsForFlag.ChangePTResourceConfirmation,
              parameters: result.parameters,
              result: result,
              id: ptrId,
              type: result.parameters[0].type,
              obj: obj
            }
            setOpenConfirmationModal(true);
            setCommonPopupParameters(param);
          }
          //  else if (result?.parameters && ['Dialog.SelectRadioButton','APIGrid','Edm.String','Label','Edm.Date','Edm.DateTime','Dialog.ConfirmSingleLine'].includes(result.parameters[0].type)) {
          //   if(isRemarkItem) {
          //     result.parameters = result.parameters.map(item => (
          //       item.type === 'Edm.Date' || item.type === 'Edm.TimeOfDay'
          //         ? { ...item, defaultValue: data?.defaultValue }
          //         : item
          //     ));
          //   }
          //   const param = {
          //     title: result?.parameters[0]?.caption ? result?.parameters[0]?.caption : i18_en.navitransTransportPlanning,
          //     for: actionFor,
          //     parameters: result.parameters,
          //     options : data?.data,
          //     key : data?.key,
          //     obj : obj,
          //     id : id,
          //     result: result?.data
          //   };
          //   setopenConfirmationModal(true);
          //   setCommonPopupParameters(param);
          // } 
          else if (service.apiOKResultChecker(result)) {
            setSuccessSnackbarAndMessage(i18_en.operationSuccessful);
            setOpenConfirmationModal(false);
            dispatch(areaSelectionRefreshReducer({ isRefresh: true }));
          }
        }
      }
    })
      .catch(error => {
        console.error('API error:', error);
      })
      .finally(() => {
        //   setIsLoading(false);
      })
  }

  const RemoveSelected = (_tempData, value, flag) => {
    let obj = _.cloneDeep(drageItemsData)
    let ptrId = ''
    let movIds = []
    obj.forEach(element => {
      if (element.source == Consts.Movements && (!flag || flag == Consts.Movements)) {
        element.items.actualSelectedIds = element.items.actualSelectedIds.filter(x => _tempData?.movementIds.indexOf(x) == -1)
        element.items.partialSelectedIds = element.items.partialSelectedIds.filter(x => _tempData?.movementIds.indexOf(x) == -1)
        if (value) {
          if (value?.operationDetail?.[0]?.result) {
            ptrId = JSON.parse(value.operationDetail[0].result)?.partialTripId?.replaceAll('{', '').replaceAll('}', '')?.toLowerCase();
          }
          element.items.actualSelectedIds = element.items.actualSelectedIds.filter(x => value?.movementlines?.map(e => e.movementId).indexOf(x) == -1)
          element.items.partialSelectedIds = element.items.partialSelectedIds.filter(x => value?.movementlines?.map(e => e.movementId).indexOf(x) == -1)
        }
      } else if (element.source == Consts.PartialTrips && (!flag || flag == Consts.PartialTrips)) {
        element.items.actualSelectedIds = element.items.actualSelectedIds.filter(x => _tempData?.partialTripIds.indexOf(x) == -1)
        element.items.partialSelectedIds = element.items.partialSelectedIds.filter(x => _tempData?.partialTripIds.indexOf(x) == -1)
        if (value) {
          movIds = value;
        }
      }
    });
    // RefreshData(obj)
    if (ptrId) {
      // CODE TO ADD DOTTED LINES IN THE MAP
      // let dottedLines = obj.find(x => x.source == 'dottedLineIds')
      // if (!_.isNil(dottedLines)) {
      //   dottedLines?.ids?.push(ptrId)
      // } else {
      //   obj.push({ source: 'dottedLineIds', ids: [ptrId] })
      // }
      addDataToMap([{ id: ptrId, source: Consts.PartialTrips }], obj, Consts.PartialTrips, [])
    } else if (movIds.length > 0) {
      addDataToMap(null, obj, Consts.Movements, movIds)
    } else {
      setDrageItemsData(obj)
      storageService.setLocalStorageData('mapItem', JSON.stringify(obj));
      //RefreshData(obj)
    }
    dispatchSelection();

    // dispatch(listSelectionReducer(existingListSelection));
  }

  const dispatchSelection = () => {
    const getListSelection = storageService.getLocalStorageData('listSelection');
    let existingListSelection = getListSelection ? JSON.parse(getListSelection) : [];

    if (!existingListSelection.movementIds) existingListSelection.movementIds = [];
    if (!existingListSelection.partialTripIds) existingListSelection.partialTripIds = [];
    if (!existingListSelection.routeIds) existingListSelection.routeIds = [];

    dispatch(listSelectionReducer(existingListSelection));
    storageService.setLocalStorageData('listSelection', JSON.stringify(existingListSelection));
  };

  //#region Plan actions

  const handleDrop = (e) => {
    const layerId = e?.nativeEvent?.srcElement?._leaflet_id;
    if (drageItems?.source == Consts.Movements || drageItems?.source == Consts.PartialTrips) {
      addDataToMap(drageItems?.items, drageItemsData, drageItems?.source, [])
    } else if (layerId) {
      setDroppedEventId(layerId)
      // childRef.current.onDropEvent(layerId); //To send data to child
      const layer = childRef.current.mapRef.current._targets[layerId];
      if (layer?.options?.item) {
        if (layer?.options?.item?.source != Consts.PartialTrips) {
          setErrorSnackbarOpen(true);
          setErrorSnackbarMessage(i18_en.cantDropOnMovement);
        } else {
          const ptrId = layer?.options?.item?.id;
          const resources = service.getMapping(drageItems?.items[0].resourceType)
          if (resources && (drageItems?.items?.[0][resources[0]] != layer?.options?.item[resources[1]])) {
            let resourceData = drageItems?.items?.[0];

            let obj = {
              fromMap: true,
              resourceType: resourceData?.resourceType,
              resourceCode: resourceData?.resourceNo,
            }
            callAPIChangePtResource(ptrId, obj)
          }
        }
      }
    }
  };

  const addDataToMap = (data, _dragItemObj, source, _ids) => {
    if (data || _ids?.length > 0) {
      const clone = _.cloneDeep(_dragItemObj);
      let tmpdata = clone?.filter(e => e.source == source);
      if (tmpdata.length > 0) {
        const ids = _ids?.length > 0 ? _ids : data?.map(e => e.id);
        tmpdata[0].items.partialSelectedIds = _.uniq(_.concat(tmpdata[0].items.partialSelectedIds, ids))
      } else {
        if (source) {
          clone.push({
            source: source,
            items: {
              actualSelectedIds: [],
              partialSelectedIds: _ids?.length > 0 ? _ids : data?.map(e => e.id),
            }
          })
        }
      }
      setDrageItemsData(clone);
      storageService.setLocalStorageData('mapItem', JSON.stringify(clone));
      // RefreshData(clone);
    }
  };

  const allowDrop = (e) => {
    e.preventDefault();
  };

  const handleClick = () => {
    setFlagShow(!isShow);
  }

  const onPushpinIconClick = (event) => {
    setIsMap(!isMap);
    setActive(!isActive)
  }
  const onPopup = (routeName, isClose) => {
    const href = window.location.href
    const path = href.substring(0, href.lastIndexOf("/") + 0);
    window.open(path + routeName, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,height=200")
  }

  const onSelectionChange = (data) => {
    // const tTilesdata = tileItems.filter(e => e.id == data.id)
    // setTileItems(tData);
  }

  const getSelectedValues = () => {
    // const tTilesdata = tileItems.filter(e => e.id == data.id)
    // setTileItems(tData);
  }

  const childHandler = (params) => {
    onPlanButtons(params)
  }

  //#endregion  Common methods

  return (
    <>
      {isLoading ? (<Spinner />) : (<></>)
      }
      <Box component="main" sx={{ flexGrow: 1, p: 1 }} onDrop={handleDrop}
        onDragOver={allowDrop}>
        {isMap && <Box className="headBG" sx={{ px: 1, display: "flex", justifyContent: "space-between", alignItems: "center", }}>
          <Typography variant="body2" color="secondary.contrastText" sx={{ fontWeight: 500 }}>Map </Typography>
        </Box>}

        <Box className="subheadBG" sx={{ px: 1, display: "flex", justifyContent: "space-between", backgroundColor: '#fafafa', borderWidth: 1, borderStyle: 'solid', borderColor: '#ebebeb', alignItems: "center", }}>
          <Typography variant="body2" color="primary" sx={{ fontWeight: 700 }}>{totalItemsSelected?.length ? totalItemsSelected.length : 0} Items On Map </Typography>
          <Stack direction="row" spacing={1}>
            {mapPlanActions?.length > 0 && mapPlanActions.map((item) => {
              if (service.planActions.filter(e => e.key == item).length > 0) {
                const planActionBtn = service.planActions.filter(e => e.key == item)[0]

                return (
                  <>
                    <Tooltip placement="bottom" title={planActionBtn?.title}>
                      {planActionBtn?.btnType == "Button" && (
                        <Button variant="outlined"
                          id={planActionBtn.key}
                          className={eval(planActionBtn.class)}
                          onClick={() => eval(planActionBtn?.onClick)}
                          disabled={eval(planActionBtn?.disabled)}
                          size="small" sx={{ px: .0, minWidth: '34px' }}>
                          {planActionBtn.icon}
                        </Button>
                      )
                      }
                      {planActionBtn.btnType == "IconButton" && (
                        <IconButton size="large" sx={{ m: 0, p: 0, marginTop: .5, }} color="primary"
                          id={planActionBtn.key}
                          className={eval(planActionBtn?.class)}
                          onClick={() => eval(planActionBtn?.onClick)}
                          disabled={eval(planActionBtn?.disabled)}>
                          {planActionBtn.icon}
                        </IconButton>
                      )}
                    </Tooltip>
                  </>
                )
              }
            })}
            {isPin &&
              <IconButton size="small" aria-label="" >
                <span>
                  <IconButton size="large" sx={{ m: 0, p: 0, marginTop: .5, }} style={{ transform: `rotate(${isActive ? '45deg' : '0deg'})` }} aria-label="show 4 new mails" color="primary"
                    onClick={(event) => onPushpinIconClick(event)}>
                    <PushPinOutlinedIcon />
                  </IconButton>
                </span>
              </IconButton>
            }
          </Stack>
        </Box>


        <Grid className='grid-container mapA' container sx={{ marginTop: 0, pt: 0, width: '100%' }}  >
          {isShow &&
            <Grid className='grid-column filterbar-bg' item elevation={0} width={350} square sx={{ backgroundColor: '#d7edfb', padding: '5px', overflow: 'auto' }}  >
              <MovementDetails tileItems={tileItems} sendToParent={onSelectionChange} />
              {/* <Card variant="outlined" square sx={{ marginBottom: '10px' }}>{card}</Card>
              <Card variant="outlined" square sx={{ marginBottom: '10px' }}>{card}</Card>
              <Card variant="outlined" square sx={{ marginBottom: '10px' }}>{card}</Card> */}
            </Grid>
          }

          <Grid item elevation={0} sx={{ flexGrow: 0, pl: '0', alignItems: 'center' }}>
            <Box className="arrow-btn" onClick={handleClick}>
              {isShow ? <ArrowBackIosRoundedIcon sx={{ width: '15px' }} color='secondary.contrastText' /> : <ArrowForwardIosRoundedIcon sx={{ width: '15px' }} color='secondary.contrastText' />}
            </Box>
          </Grid>
          <Grid item elevation={0} sx={{ flexGrow: 1, pl: '0' }}>
            <LeafletMap
              key={mapKey}
              ref={childRef}
              draggable
              zoom={8}
              center={center}
              data={mapDetails}
              // sendDataToParent={(e, item) => locationClicked(item)} 
              onDrop={handleDrop}
              onDragOver={allowDrop}
              selectionCluster={isEnableCluster}
              selectionRectangular={isEnableRectSelection}
              selectionLasso={isEnableLassoSelection}
              selectionMarker={isEnableMarkerSelection}
              selectionRoute={isEnableRouteSelection}
              coordinatesData={coordinatesData}
              sendDataToParent={childHandler} />
          </Grid>
        </Grid>
      </Box>
      {openConfirmationModal && <ModalComponent message={errorMessage} params={commonPopupParameters} openConfirmationModal={openConfirmationModal} closeConfirmationModal={closeConfirmationModal} />}
      <AlertComponent isSuccessSnackbarOpen={isSuccessSnackbarOpen} successSnackbarMessage={successSnackbarMessage} handleSuccessSnackbarClose={handleSuccessSnackbarClose} isErrorSnackbarOpen={isErrorSnackbarOpen} errorSnackbarMessage={errorSnackbarMessage} handleErrorSnackbarClose={handleErrorSnackbarClose} isDisplayDrillDownButton={isDisplayDrillDownButton} drillDownButtonURL={drillDownButtonURL} />

      {/*open modal for plan on new trip details */}
      {openPlanNewTripPopup && <WindowComponent title={"Plan New Trip"} visible={openPlanNewTripPopup} initialWidth={420} initialHeight={200} minWidth={420} minHeight={200} onClose={() => setOpenPlanNewTripPopup(false)} dataComponent={PlanNewTripData} actionButtons={<PlanNewTripActionButtons />} />}

    </>

  )
}

export default MapView;
